import { ElementSource } from "chq";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";

const findElementByName = (
  elements: ElementSource[] | undefined,
  name: typeof ELEMENT_NAMES[keyof typeof ELEMENT_NAMES]
): ElementSource | undefined => {
  const lowerCaseName = name.toLowerCase();
  return elements?.find(element => element.name?.toLowerCase() === lowerCaseName);
};

export default findElementByName;
